import { Component, Host, h, Prop } from '@stencil/core';
import spinner from '@se/icons/svg/spinner.svg';

export type LoadingSpinnerVisibleType = 'visible' | 'hidden';

@Component({
  tag: 'loading-spinner',
  styleUrl: 'loading-spinner.scss',
  shadow: false,
  scoped: true
})
export class LoadingSpinner {
  @Prop({attribute: 'visible'}) readonly visible: LoadingSpinnerVisibleType = 'hidden';
  @Prop({attribute: 'label'}) readonly label: string;

  render() {
      return (
        <Host class={{'hidden' : (this.visible === 'hidden')}}>
          <div class={'spinner-dialog'}>
            <div class="loading-icon" innerHTML={spinner}></div>
            <span class={'label'}></span>
          </div>
        </Host>
      );
  }
}
